const MILESTONE_POINTS_ARRAY: number[] = [
  1000, 5000, 10000, 15000, 25000, 30000, 40000, 75000, 125000, 175000, 225000,
  275000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1250000,
  1500000, 1750000,
];

const MILESTONE_STREAKS_ARRAY: number[] = [1, 2, 4, 6, 8, 10, 20, 30, 40, 52];

const pointsMilestones: Set<number> = new Set(MILESTONE_POINTS_ARRAY);
const streaksMilestones: Set<number> = new Set(MILESTONE_STREAKS_ARRAY);

/**
 * Checks if the given points value is an exact match for one of the defined milestones.
 * Handles parsing if the input is a specific API string format "points__<milestone>".
 * @param pointsData - The current points value, which can be a number or the API string format.
 * @returns {boolean} True if the points exactly match a milestone, false otherwise.
 */
export function isPointsMilestone(
  pointsData: string | number | undefined | null
): boolean {
  let currentPoints: number | undefined;

  if (typeof pointsData === "string") {
    currentPoints = parseInt(pointsData.replace("points__", ""));
  } else if (typeof pointsData === "number") {
    currentPoints = pointsData;
  }

  if (typeof currentPoints === "number" && currentPoints > 0) {
    return pointsMilestones.has(currentPoints);
  }

  return false;
}

export function isStreakMilestone(
  streakDuration: number | undefined | null
): boolean {
  if (!streakDuration) {
    return false;
  }

  return streaksMilestones.has(streakDuration);
}
